import CommonLayout from "../../layouts/CommonLayout";
import { useNavigate } from 'react-router-dom';
import Terms from '../../../../common/Terms';

const TermsPage = () => {
    const navigate = useNavigate();
    return (
        <CommonLayout title="이용약관" onBack={() => navigate('/app/mypage')}>
            <Terms />
        </CommonLayout>
    );
};

export default TermsPage;
